import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'scrollable-wrapper',
    template: `
<ng-content></ng-content>
`,
    styles: [`
::ng-deep scrollable-wrapper { position:relative; flex-direction: column; overflow: hidden; height: 100%; overflow-y: auto; padding: 20px; margin: 0 20px 20px 20px; border-radius: 6px; border: 1px solid #dddddd; }
@media screen and (max-width: 768px) { ::ng-deep scrollable-wrapper { padding: 0px; } }
`],
    standalone: true,
    imports: [CommonModule],
})
export class ScrollableWrapper {}





